<div class="contact-list" data-tour="contacts-overview">
  <h2 data-tour-ready="contacts-overview">
    {{ 'CONTACTS.EMPLOYEES' | translate }}
    <span class="table-total">({{ employeesTotalCount }})</span>
  </h2>
  <button nz-button nzType="primary" (click)="openAddModal('employee')" style="margin-bottom: 10px;">
    {{ 'CONTACTS.ADD_EMPLOYEE' | translate }}
  </button>

  <div class="search-input">
    <nz-input-group [nzSuffix]="suffixIcon">
      <input nz-input [(ngModel)]="employeeSearchTerm" (ngModelChange)="filterEmployees()" placeholder="{{ 'CONTACTS.SEARCH_EMPLOYEES' | translate }}" />
      <ng-template #suffixIcon><span nz-icon nzType="search"></span></ng-template>
    </nz-input-group>
  </div>

  <nz-table
    [nzData]="employees"
    [nzBordered]="true"
    [nzLoading]="isLoadingEmployees"
    [nzShowPagination]="false"
    [nzScroll]="{ x: '750px' }"
  >
    <thead>
    <tr>
      <th nzColumnKey="name" [nzSortOrder]="employeesSort.value" (nzSortOrderChange)="onEmployeesSortChange('name', $event)">
        {{ 'CONTACTS.NAME' | translate }}
      </th>
      <th
        nzColumnKey="email"
        [nzSortOrder]="employeesSort.value"
        (nzSortOrderChange)="onEmployeesSortChange('email', $event)"
        *ngIf="showEmailFieldTable"
      >
        {{ 'CONTACTS.EMAIL' | translate }}
      </th>
      <th
        nzColumnKey="phone"
        [nzSortOrder]="employeesSort.value"
        (nzSortOrderChange)="onEmployeesSortChange('phone', $event)"
        *ngIf="showPhoneFieldTable"
      >
        {{ 'CONTACTS.PHONE' | translate }}
      </th>
      <th
        nzColumnKey="mobile"
        [nzSortOrder]="employeesSort.value"
        (nzSortOrderChange)="onEmployeesSortChange('mobile', $event)"
        *ngIf="showPhoneFieldTable"
      >
        {{ 'CONTACTS.MOBILE' | translate }}
      </th>
      <th nzColumnKey="role" [nzSortOrder]="employeesSort.value" (nzSortOrderChange)="onEmployeesSortChange('role', $event)">
        {{ 'CONTACTS.ROLE' | translate }}
      </th>
      <th class="actions-cell">{{ 'CONTACTS.ACTIONS' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let employee of employees">
      <td>{{ employee.name }}</td>
      <td *ngIf="showEmailFieldTable">{{ employee.email }}</td>
      <td *ngIf="showPhoneFieldTable">{{ formatGermanPhoneNumber(employee?.phone) }}</td>
      <td *ngIf="showPhoneFieldTable">
        <ng-container *ngIf="employee?.mobile; else employeeMobileDash">
          {{ formatGermanPhoneNumber(employee?.mobile) }}
        </ng-container>
        <ng-template #employeeMobileDash>—</ng-template>
      </td>
      <td>{{ getTranslatedRole(employee.role) }}</td>
      <td class="actions-cell">
        <div class="actions-inline">
          <button
            nz-button
            nzType="text"
            nz-tooltip
            class="icon-action-button"
            (click)="openEditModal(employee, 'employee')"
            [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
            [attr.aria-label]="'CONTACTS.EDIT' | translate"
          >
            <span nz-icon nzType="edit"></span>
          </button>

          <button
            nz-button
            nzType="text"
            nz-tooltip
            class="icon-action-button"
            nzDanger
            (click)="deleteEmployee(employee)"
            [nzLoading]="deletingEmployeeId === employee._id"
            [nzTooltipTitle]="'CONTACTS.DELETE' | translate"
            [attr.aria-label]="'CONTACTS.DELETE' | translate"
          >
            <span nz-icon nzType="delete"></span>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <nz-pagination
    [nzPageIndex]="employeesPagination.pageIndex"
    [nzPageSize]="employeesPagination.pageSize"
    [nzTotal]="employeesPagination.total"
    [nzPageSizeOptions]="[5, 10, 20, 50]"
    [nzShowQuickJumper]="true"
    [nzShowSizeChanger]="true"
    (nzPageIndexChange)="onEmployeesPageIndexChange($event)"
    (nzPageSizeChange)="onEmployeesPageSizeChange($event)"
    style="margin-top: 16px; text-align: right;"
  ></nz-pagination>

  <!-- Caretakers Table -->
  <h2>
    {{ 'CONTACTS.CARETAKERS' | translate }}
    <span class="table-total">({{ caretakersTotalCount }})</span>
  </h2>
  <button nz-button nzType="primary" (click)="openAddModal('caretaker')" style="margin-bottom: 10px;">
    {{ 'CONTACTS.ADD_CARETAKER' | translate }}
  </button>

  <div class="search-input">
    <nz-input-group [nzSuffix]="suffixIcon2">
      <input nz-input [(ngModel)]="caretakerSearchTerm" (ngModelChange)="filterCaretakers()" placeholder="{{ 'CONTACTS.SEARCH_CARETAKERS' | translate }}" />
      <ng-template #suffixIcon2><span nz-icon nzType="search"></span></ng-template>
    </nz-input-group>
  </div>

  <nz-table
    [nzData]="caretakers"
    [nzBordered]="true"
    [nzLoading]="isLoadingCaretakers"
    [nzShowPagination]="false"
    [nzScroll]="{ x: '1000px' }"
  >
    <thead>
    <tr>
      <th nzColumnKey="name" [nzSortOrder]="caretakersSort.value" (nzSortOrderChange)="onCaretakersSortChange('name', $event)">
        {{ 'CONTACTS.NAME' | translate }}
      </th>
      <th
        nzColumnKey="contactPerson"
        [nzSortOrder]="caretakersSort.value"
        (nzSortOrderChange)="onCaretakersSortChange('contactPerson', $event)"
      >
        {{ 'CONTACTS.CONTACT_PERSONS' | translate }}
      </th>
      <th nzColumnKey="email" [nzSortOrder]="caretakersSort.value" (nzSortOrderChange)="onCaretakersSortChange('email', $event)">
        {{ 'CONTACTS.EMAIL' | translate }}
      </th>
      <th nzColumnKey="phone" [nzSortOrder]="caretakersSort.value" (nzSortOrderChange)="onCaretakersSortChange('phone', $event)">
        {{ 'CONTACTS.PHONE' | translate }}
      </th>
      <th nzColumnKey="mobile" [nzSortOrder]="caretakersSort.value" (nzSortOrderChange)="onCaretakersSortChange('mobile', $event)">
        {{ 'CONTACTS.MOBILE' | translate }}
      </th>
      <th nzColumnKey="emergencyNumber" [nzSortOrder]="caretakersSort.value" (nzSortOrderChange)="onCaretakersSortChange('emergencyNumber', $event)">
        {{ 'CONTACTS.EMERGENCY_NUMBER' | translate }}
      </th>
      <th
        nzColumnKey="address"
        [nzSortOrder]="caretakersSort.value"
        (nzSortOrderChange)="onCaretakersSortChange('address', $event)"
      >
        {{ 'CONTACTS.ADDRESS' | translate }}
      </th>
      <th class="actions-cell">{{ 'CONTACTS.ACTIONS' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let caretaker of caretakers">
      <td>{{ caretaker.name }}</td>
      <td>
        <ng-container *ngIf="getCaretakerContactSummary(caretaker); else caretakerContactDash">
          {{ getCaretakerContactSummary(caretaker) }}
        </ng-container>
        <ng-template #caretakerContactDash>—</ng-template>
      </td>
      <td>{{ caretaker.email }}</td>
      <td>{{ formatGermanPhoneNumber(caretaker?.phone) }}</td>
      <td>{{ formatGermanPhoneNumber(caretaker?.mobile) }}</td>
      <td>
        <ng-container *ngIf="caretaker?.emergencyNumber; else caretakerEmergencyDash">
          {{ formatGermanPhoneNumber(caretaker?.emergencyNumber) }}
        </ng-container>
        <ng-template #caretakerEmergencyDash>—</ng-template>
      </td>
      <td>{{ caretaker.address }}</td>
      <td class="actions-cell">
        <div class="actions-inline">
          <button
            nz-button
            nzType="text"
            nz-tooltip
            class="icon-action-button"
            (click)="openEditModal(caretaker, 'caretaker')"
            [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
            [attr.aria-label]="'CONTACTS.EDIT' | translate"
          >
            <span nz-icon nzType="edit"></span>
          </button>

          <button
            nz-button
            nzType="text"
            nz-tooltip
            class="icon-action-button"
            nzDanger
            (click)="deleteCaretaker(caretaker)"
            [nzLoading]="deletingCaretakerId === caretaker._id"
            [nzTooltipTitle]="'CONTACTS.DELETE' | translate"
            [attr.aria-label]="'CONTACTS.DELETE' | translate"
          >
            <span nz-icon nzType="delete"></span>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <!-- External Pagination Component for Caretakers -->
  <nz-pagination
    [nzPageIndex]="caretakersPagination.pageIndex"
    [nzPageSize]="caretakersPagination.pageSize"
    [nzTotal]="caretakersPagination.total"
    [nzPageSizeOptions]="[5, 10, 20, 50]"
    [nzShowQuickJumper]="true"
    [nzShowSizeChanger]="true"
    (nzPageIndexChange)="onCaretakersPageIndexChange($event)"
    (nzPageSizeChange)="onCaretakersPageSizeChange($event)"
    style="margin-top: 16px; text-align: right;"
  ></nz-pagination>

  <!-- Services Table -->
  <h2>
    {{ 'CONTACTS.SERVICES' | translate }}
    <span class="table-total">({{ servicesTotalCount }})</span>
  </h2>
  <button nz-button nzType="primary" (click)="openAddModal('service')" style="margin-bottom: 10px;">
    {{ 'CONTACTS.ADD_SERVICE' | translate }}
  </button>

  <div class="search-input">
    <nz-input-group [nzSuffix]="suffixIcon3">
      <input nz-input [(ngModel)]="serviceSearchTerm" (ngModelChange)="filterServices()" placeholder="{{ 'CONTACTS.SEARCH_SERVICES' | translate }}" />
      <ng-template #suffixIcon3><span nz-icon nzType="search"></span></ng-template>
    </nz-input-group>
  </div>

  <nz-table
    [nzData]="services"
    [nzBordered]="true"
    [nzLoading]="isLoadingServices"
    [nzShowPagination]="false"
    [nzScroll]="{ x: '1080px' }"
  >
    <thead>
    <tr>
      <th
        nzColumnKey="serviceName"
        [nzSortOrder]="servicesSort.value"
        (nzSortOrderChange)="onServicesSortChange('serviceName', $event)"
        nzWidth="200px"
      >
        {{ 'CONTACTS.SERVICE_NAME' | translate }}
      </th>
      <th
        nzColumnKey="phone"
        [nzSortOrder]="servicesSort.value"
        (nzSortOrderChange)="onServicesSortChange('phone', $event)"
        nzWidth="120px"
      >
        {{ 'CONTACTS.PHONE' | translate }}
      </th>
      <th
        nzColumnKey="mobile"
        [nzSortOrder]="servicesSort.value"
        (nzSortOrderChange)="onServicesSortChange('mobile', $event)"
        nzWidth="120px"
      >
        {{ 'CONTACTS.MOBILE' | translate }}
      </th>
      <th
        nzColumnKey="emergencyNumber"
        [nzSortOrder]="servicesSort.value"
        (nzSortOrderChange)="onServicesSortChange('emergencyNumber', $event)"
        nzWidth="128px"
      >
        {{ 'CONTACTS.EMERGENCY_NUMBER' | translate }}
      </th>
      <th
        nzColumnKey="email"
        [nzSortOrder]="servicesSort.value"
        (nzSortOrderChange)="onServicesSortChange('email', $event)"
        nzWidth="200px"
      >
        {{ 'CONTACTS.EMAIL' | translate }}
      </th>
      <th
        nzColumnKey="serviceType"
        [nzSortOrder]="servicesSort.value"
        (nzSortOrderChange)="onServicesSortChange('serviceType', $event)"
        nzWidth="320px"
      >
        {{ 'CONTACTS.SERVICE_TYPES' | translate }}
      </th>
      <th class="actions-cell" nzWidth="92px">{{ 'CONTACTS.ACTIONS' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let service of services">
      <td class="service-name-cell">{{ service.serviceName }}</td>
      <td class="service-contact-cell">
        <ng-container *ngIf="service?.phone; else servicePhoneDash">
          {{ formatGermanPhoneNumber(service?.phone) }}
        </ng-container>
        <ng-template #servicePhoneDash>—</ng-template>
      </td>
      <td class="service-contact-cell">
        <ng-container *ngIf="service?.mobile; else dash">
          {{ formatGermanPhoneNumber(service?.mobile) }}
        </ng-container>
        <ng-template #dash>—</ng-template>
      </td>
      <td class="service-contact-cell">
        <ng-container *ngIf="service?.emergencyNumber; else emergencyDash">
          {{ formatGermanPhoneNumber(service?.emergencyNumber) }}
        </ng-container>
        <ng-template #emergencyDash>—</ng-template>
      </td>
      <td class="service-email-cell" [attr.title]="service?.email || null">
        <ng-container *ngIf="service?.email; else emailDash">
          {{ service.email }}
        </ng-container>
        <ng-template #emailDash>—</ng-template>
      </td>
      <td class="service-types-cell" [attr.title]="getTranslatedServiceTypes(service)">{{ getTranslatedServiceTypes(service) }}</td>
      <td class="actions-cell">
        <div class="actions-inline">
          <button
            nz-button
            nzType="text"
            nz-tooltip
            class="icon-action-button"
            (click)="openEditModal(service, 'service')"
            [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
            [attr.aria-label]="'CONTACTS.EDIT' | translate"
          >
            <span nz-icon nzType="edit"></span>
          </button>
          <button
            nz-button
            nzType="text"
            nz-tooltip
            class="icon-action-button"
            nzDanger
            (click)="deleteService(service)"
            [nzLoading]="deletingServiceId === service._id"
            [nzTooltipTitle]="'CONTACTS.DELETE' | translate"
            [attr.aria-label]="'CONTACTS.DELETE' | translate"
          >
            <span nz-icon nzType="delete"></span>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <!-- External Pagination Component for Services -->
  <nz-pagination
    [nzPageIndex]="servicesPagination.pageIndex"
    [nzPageSize]="servicesPagination.pageSize"
    [nzTotal]="servicesPagination.total"
    [nzPageSizeOptions]="[5, 10, 20, 50]"
    [nzShowQuickJumper]="true"
    [nzShowSizeChanger]="true"
    (nzPageIndexChange)="onServicesPageIndexChange($event)"
    (nzPageSizeChange)="onServicesPageSizeChange($event)"
    style="margin-top: 16px; text-align: right;"
  ></nz-pagination>

</div>
